import GridRoadmap from "layout/atoms/GridRoadmap";
import Label from "layout/atoms/Label";
import Loader from "layout/atoms/Loader";
import MainContainer from "layout/atoms/MainContainer";
import EmptyState from "layout/molecules/EmptyState";
import IdeaCardSmall from "layout/organisms/IdeaCardSmall";
import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { selectCurrentBoardData } from "store/currentBoardSlice";

const ROADMAP_STATUSES = ["REVIEW", "PLANNED", "IN_PROGRESS", "COMPLETE"];

function BoardRoadmap() {
  const { t } = useTranslation();
  const { boardId } = useParams();
  const currentBoardData = useSelector(selectCurrentBoardData);

  const IdeasList = () => {
    return currentBoardData.ideas.ideas.length !== 0 ? (
      <GridRoadmap>
        {ROADMAP_STATUSES.map((status) => {
          const statusIdeas = [...currentBoardData.ideas.ideas].filter((a) => a.status === status);
          return (
          <div key={status}>
            <Label status={status}>{`${t(`statuses.${status}`)} (${statusIdeas.length})`}</Label>
            {statusIdeas
              .sort((a, b) => b.commentCount - a.commentCount)
              .map((idea) => (
                <IdeaCardSmall
                  key={idea.id}
                  ideaId={idea.id}
                  boardId={boardId}
                />
              ))}
          </div>
          );
        })}
      </GridRoadmap>
    ) : (
      <EmptyState
        type="noIdeas"
        header={t("emptyStates.ideas.header")}
        subheader={t("emptyStates.ideas.subheader")}
      />
    );
  };

  return (
    <MainContainer
      topbar={
        <div>
          <h2>{t("boardsDetails.roadmap.header")}</h2>
        </div>
      }
    >
      {currentBoardData.ideas.status.fetchIdeas === "loading" ? (
        <Loader />
      ) : (
        <IdeasList />
      )}
    </MainContainer>
  );
}

export default BoardRoadmap;
